import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/live_session`;

class LiveSessionServices {
  async getLiveSessionData(activeGame, opts = {}) {
    try {
      const action = API_ROUTE + `/running-game/${activeGame}`;
      return await requestToken.get(action, undefined, {
        signal: opts.signal,
      });
    } catch (error) {
      if (opts.signal?.aborted || error?.name === "AbortError" || error?.code === "ERR_CANCELED") return;
      console.error("Error in getLiveSessionData:", error);
      throw error;
    }
  }

  async getYantraListData(opts = {}) {
    try {
      const action = API_ROUTE + `/yantralist-data`;
      const response = await requestToken.get(action, undefined, {
        signal: opts.signal,
      });
      return response;
    } catch (error) {
      if (opts.signal?.aborted || error?.name === "AbortError" || error?.code === "ERR_CANCELED") return;
      console.error("Error in getYantraListData:", error);
      throw error;
    }
  }

  async getTodayLastDraw(activeGame, opts = {}) {
    try {
      const action = API_ROUTE + `/today-last-draw/${activeGame}`;
      const response = await requestToken.get(action, undefined, {
        signal: opts.signal,
      });
      return response;
    } catch (error) {
      if (opts.signal?.aborted || error?.name === "AbortError" || error?.code === "ERR_CANCELED") return;
      console.error("Error in getTodayLastDraw:", error);
      throw error;
    }
  }

  async getLiveActivity(gameType) {
    try {
      const action = API_ROUTE + `/live-activity/${gameType}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getLiveActivity:", error);
      throw error;
    }
  }

  async getProfitLoss(sessionDbId) {
    try {
      const action = API_ROUTE + `/profit-loss/${sessionDbId}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getProfitLoss:", error);
      throw error;
    }
  }

  async savePlaceBetData(payload) {
    try {
      const action = API_ROUTE + `/save-place-bet-data`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Error in savePlaceBetData:", error);
      throw error;
    }
  }

  async getCurrentSessionPlaceBets(sessionId) {
    try {
      const response = await requestToken.get(
        `${API_ROUTE}/current-session-place-bets?session_id=${sessionId}`,
      );
      return response;
    } catch (error) {
      console.error("Error in getCurrentSessionPlaceBets:", error);
      throw error;
    }
  }

  /** Super Admin only: per-user yantra 1–10 bet units for a session (numeric game_sessions.id). */
  async getSuperAdminSessionPurchaseGrid(sessionDbId, opts = {}) {
    try {
      const sid = encodeURIComponent(String(sessionDbId || ""));
      const response = await requestToken.get(
        `${API_ROUTE}/super-admin-session-purchase-grid?session_id=${sid}`,
        undefined,
        { signal: opts.signal },
      );
      return response;
    } catch (error) {
      if (
        opts.signal?.aborted ||
        error?.name === "AbortError" ||
        error?.code === "ERR_CANCELED"
      )
        return;
      console.error("Error in getSuperAdminSessionPurchaseGrid:", error);
      throw error;
    }
  }

  async scanBarCode(barCode, opts = {}) {
    try {
      const action =
        API_ROUTE +
        `/scan-bar-code?code=${encodeURIComponent(barCode || "")}`;
      const response = await requestToken.get(action, {
        signal: opts.signal,
      });
      return response;
    } catch (error) {
      if (
        opts.signal?.aborted ||
        error?.name === "AbortError" ||
        error?.code === "ERR_CANCELED"
      )
        return;
      console.error("Error in scanBarCode:", error);
      throw error;
    }
  }

  async cancelPlaceBet(placeBetId) {
    try {
      const action = API_ROUTE + `/cancel-place-bet`;
      const response = await requestToken.post(action, {
        place_bet_id: placeBetId,
      });
      return response;
    } catch (error) {
      console.error("Error in cancelPlaceBet:", error);
      throw error;
    }
  }
}

export default LiveSessionServices;
